import { createFileRoute } from '@tanstack/react-router';
import DocumentsPage from '../../components/pages/documents';
import { requireAccess } from '../../auth/authUtils';

export const Route = createFileRoute('/documents/')({
  component: DocumentsPage,
  head: () => ({
    meta: [
      {
        title: 'Documents | Ingle Lewer',
      },
    ],
  }),
  beforeLoad: async ({ context }) => {
    requireAccess(context);
  },
});
